var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow down",
    clipPath: "url(#clip0_1303_5961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01047 3.5764L6.64222 0.953651C6.78593 0.800956 6.78593 0.567421 6.64222 0.4237C6.49851 0.27999 6.25599 0.27999 6.11227 0.4237L3.74997 2.786L1.38766 0.4237C1.23496 0.27999 1.00146 0.27999 0.857708 0.4237C0.714007 0.567411 0.714007 0.800946 0.857708 0.953651L3.48047 3.5764C3.63316 3.72011 3.86675 3.72011 4.01047 3.5764Z",
    fill: "#F86557"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1303_5961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6.5,
    fill: "white",
    transform: "matrix(0 1 -1 0 7 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSmall);
export default __webpack_public_path__ + "static/media/arrow-down-small.b21bdc5c9964a899b1dd7b8416ef128a.svg";
export { ForwardRef as ReactComponent };